module.exports = __webpack_public_path__ + "static/media/opening3.c7548040.jpeg";